import { SvgIcon, type SvgIconProps } from '@mui/material';
import usdtBep20Png from './usdt-bep20.png';

const UsdtBep20Icon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox='0 0 225 225'>
    <image href={usdtBep20Png} width='225' height='225' />
  </SvgIcon>
);

export default UsdtBep20Icon;
